<template>
	<div class="card-item__main">
		<div class="card-item__info">
			<div class="card-item__icon">
				<i :class="iconClass" />
			</div>
			<span class="card-item__number"> ({{ number }}) </span>
			<slot name="ellipsis" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'CompanyLocationCard',
	props: {
		number: {
			type: [String, Number],
			required: true
		},
		iconClass: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.card-item {
	&__main {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: $gutter-md;
	}
	&__info {
		display: flex;
		align-items: center;
		gap: $gutter-sm;
	}
	&__icon {
		font-size: 18px;
	}
	&__number {
		font-size: $bd-txt-font-size-regular;
	}
}
</style>
